export default "__VITE_ASSET__F3kzR8GK__"